import React from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { eurf } from "./shared";

export default function AccountingView({ fin, token }) {
  if (!fin) return <p className="text-zinc-500">Chargement…</p>;
  const f = fin.fiscal;
  const dl = async (oid) => {
    try {
      const res = await axios.get(`${API}/superadmin/orgs/${oid}/subscription-invoice`, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = `facture-halgaros-${oid.slice(0, 6)}.pdf`; a.click(); window.URL.revokeObjectURL(url);
    } catch { toast.error("Erreur lors de la génération"); }
  };
  const kpi = (l, v, t) => (<div className="rounded-2xl border border-zinc-800 bg-zinc-950 p-4"><p className="text-xs text-zinc-500">{l}</p><p className="mt-1 font-display text-xl font-bold" style={{ color: t }}>{v}</p></div>);
  const exp = async (fmt) => {
    try {
      const res = await axios.get(`${API}/superadmin/finance/export?format=${fmt}`, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = `compta-halgaros.${fmt}`; a.click(); window.URL.revokeObjectURL(url);
    } catch { toast.error("Erreur lors de l'export"); }
  };
  return (
    <div className="space-y-4" data-testid="sa-accounting">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-white">Comptabilité HalgarOS</h1>
        <div className="flex gap-2">
          <button data-testid="sa-compta-csv" onClick={() => exp("csv")} className="rounded-full border border-zinc-700 px-3 py-1.5 text-xs text-zinc-200 hover:bg-zinc-800">Export CSV</button>
          <button data-testid="sa-compta-pdf" onClick={() => exp("pdf")} className="rounded-full border border-zinc-700 px-3 py-1.5 text-xs text-zinc-200 hover:bg-zinc-800">Export PDF</button>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {kpi("CA abonnements /mois (TTC)", eurf(f.ttc), "#fff")}
        {kpi(`TVA à déclarer /mois (${f.vat_rate}%)`, eurf(f.vat_due), "#38bdf8")}
        {kpi(`Charges /mois (${f.social_rate}%)`, eurf(f.social_due), "#fbbf24")}
        {kpi("Base HT /mois", eurf(f.ht), "#a1a1aa")}
      </div>
      <p className="text-xs text-zinc-500">Annualisé : TVA ≈ {eurf(f.vat_due_year)} · charges ≈ {eurf(f.social_due_year)}. Estimation indicative, non contractuelle. Taux modifiables dans Paramètres.</p>
      <div className="overflow-x-auto rounded-2xl border border-zinc-800 bg-zinc-950">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-zinc-800 text-xs uppercase text-zinc-500"><tr><th className="px-3 py-3">Prestataire</th><th className="px-3 py-3">Plan</th><th className="px-3 py-3">Montant/mois</th><th className="px-3 py-3">Statut</th><th className="px-3 py-3">Facture</th></tr></thead>
          <tbody>
            {fin.subscriptions.length === 0 && <tr><td colSpan={5} className="px-3 py-4 text-center text-zinc-500">Aucun abonnement actif.</td></tr>}
            {fin.subscriptions.map((s) => (
              <tr key={s.org_id} data-testid={`sa-subrow-${s.org_id}`} className="border-b border-zinc-800/60">
                <td className="px-3 py-2 text-white">{s.name}<div className="text-xs text-zinc-500">{s.email || "—"}</div></td>
                <td className="px-3 py-2 capitalize">{s.plan}</td>
                <td className="px-3 py-2">{eurf(s.price)}</td>
                <td className="px-3 py-2"><span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-xs text-emerald-400">{s.status}</span></td>
                <td className="px-3 py-2"><button data-testid={`sa-invoice-${s.org_id}`} onClick={() => dl(s.org_id)} className="rounded-full border border-zinc-700 px-3 py-1 text-xs text-zinc-200 hover:bg-zinc-800">PDF</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
